module.exports = __webpack_public_path__ + "bin/75a7cb04887751c08cba916885e3b5fd.png";